import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  note: {
    lineHeight: 1.5
  },
  button: {
    display: 'flex',
    fontSize: 12,
    gap: theme.spacing(2)
  },
  action: {
    fontSize: 12
  }
});

export default makeStyles(styles);
